import React from 'react';
import Headers from '../components/BaseLayout/Header';

const Header = (props) => {
  return <Headers {...props} />;
};
export default Header;
